import type { FilterRuleModel } from '@/shared/generated'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import {
	ANCHOR_STATUS,
	useAnchorGeneratedFamiliesReviewMutation,
} from '@/entities/anchor'

import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'
import { processingMessage } from '@/shared/tools/message'

import { useApprovalPageContext } from '../ui/ApprovalPageProvider'

export const useApproveAnchorFamilies = () => {
	const { t } = useTranslation()
	const { setSelected } = useApprovalPageContext()
	const anchorGeneratedFamiliesReviewMutation =
		useAnchorGeneratedFamiliesReviewMutation({
			onSuccess: () => {
				setSelected([])
				queryClient.refetchQueries({
					queryKey: ['generated-anchor-families'],
				})
			},
		})
	const handleApproveAnchorFamilies = useCallback(
		(filters: FilterRuleModel[]) => {
			ampli.anchoringAnchorApprovalClickApproveAll()
			toast.promise(
				anchorGeneratedFamiliesReviewMutation.mutateAsync({
					filters,
					status: ANCHOR_STATUS.APPROVED,
				}),
				{
					loading: processingMessage(t),
					success: t('toast.entity.updated', {
						entity: t('entity.anchor_family', {
							defaultValue: 'Anchor family',
						}),
					}),
					error: t('fatal_error_title'),
					id: 'anchor_generated_family_status_updating',
				}
			)
		},
		[anchorGeneratedFamiliesReviewMutation, t]
	)

	return {
		handleApproveAnchorFamilies,
		isPending: anchorGeneratedFamiliesReviewMutation.isPending,
	}
}
